import { useEffect, useContext } from 'react'
// We are excluding this from loading at build time in gatsby-node.js
import LocomotiveScroll from 'locomotive-scroll'
import { StoreDispatch } from '../../Store'
import { animation } from '../../styles/vars/animation.style'

const Scroll = ({ callbacks, desktop }) => {
  // const store = useContext(StoreState)
  const dispatch = useContext(StoreDispatch)

  useEffect(() => {
    window.scroll = new LocomotiveScroll({
      el: document.getElementById('scroll-container'),
      smooth: true,
      smartphone: {
        smooth: false,
      },
      tablet: {
        smooth: false,
      },
      direction: 'vertical',
      getDirection: true,
      touchMultiplier: 2.5,
      firefoxMultiplier: 70,
      lerp: 0.1,
      repeat: false,
      class: 'is-inview',
      reloadOnContextChange: true,
    })

    dispatch({ type: 'SET_SCROLL', payload: window.scroll })

    const timeout = setTimeout(() => {
      window.scroll.update()
    }, animation.maskHideDuration * 1000)

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }

      if (window.scroll) {
        window.scroll.destroy()
        dispatch({ type: 'SET_SCROLL', payload: null })
      }
    }
  }, [callbacks.pathname, desktop, dispatch])

  return null
}

export default Scroll
